/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCallLineSummaryFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type CallLineSummary, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /calls/lines
 */
export interface LinesRequestBuilder extends BaseRequestBuilder<LinesRequestBuilder> {
    /**
     * GetCallLines
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CallLineSummary[]>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CallLineSummary[] | undefined>;
    /**
     * GetCallLines
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const LinesRequestBuilderUriTemplate = "{+baseurl}/calls/lines";
/**
 * Metadata for all the requests in the request builder.
 */
export const LinesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: LinesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createCallLineSummaryFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
